import { List, Record } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

class TrumpismDTO extends Record({
  id: null,
  date: null,
  factCheck: null,
  headline: null,
  quote: null,
  sources: [],
  tweets: [],
  youTubeUrl: null
}) {
  constructor(dataObject) {
    const {
      fields: { date, factCheck, headline, quote, sources, tweets, youTubeUrl },
      sys: { id }
    } = dataObject;

    super({
      date,
      factCheck,
      headline,
      id,
      quote,
      sources: new List(sources),
      tweets: new List(tweets),
      youTubeUrl
    });
  }
}

const TrumpismPropTypes = ImmutablePropTypes.recordOf({
  date: PropTypes.string.isRequired,
  factCheck: PropTypes.string,
  headline: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  quote: PropTypes.string,
  sources: ImmutablePropTypes.listOf(PropTypes.string),
  tweets: ImmutablePropTypes.listOf(PropTypes.string),
  youTubeUrl: PropTypes.string
});

export { TrumpismDTO, TrumpismPropTypes };



// WEBPACK FOOTER //
// ./src/services/dto/trumpism.js